import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatCard, MatCardHeader, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslatePipe, AgrDatePipe, AgrCurrencyPipe, AgrNumberPipe } from '@next/core-lib/i18n';

import { TableColumn, TableColumnTypes } from '../../table.model';

@Component({
  selector: 'app-table-mobile',
  templateUrl: './table-mobile.component.html',
  styleUrls: ['./table-mobile.component.scss'],
  imports: [
    NgFor,
    MatCard,
    MatCardHeader,
    NgIf,
    MatCheckbox,
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatDivider,
    MatCardContent,
    NgTemplateOutlet,
    MatCardActions,
    MatButton,
    TranslatePipe,
    AgrDatePipe,
    AgrCurrencyPipe,
    AgrNumberPipe,
  ],
})
export class TableMobileComponent {
  public readonly tableColumnTypes = TableColumnTypes;
  public more = false;
  public expanded: { [key: number]: boolean } = {};

  @ViewChild('template') template: TemplateRef<unknown>;

  getPrimaryColumnKey(row: { [key: string]: unknown }, primaryColumn?: string) {
    return primaryColumn || Object.keys(row)[0];
  }

  filterColumns(columns: TableColumn[], primaryColumnKey: string) {
    return columns.filter((column) => column.id !== primaryColumnKey);
  }

  toggleExpanded(index: number) {
    this.expanded[index] = !(this?.expanded?.[index] ?? false);
  }

  getExpandedLabel(index: number) {
    return this?.expanded?.[index] ? 'show_less' : 'show_more';
  }
}
